import { render, staticRenderFns } from "./DoctorAssessment.vue?vue&type=template&id=f93d0e46&scoped=true"
import script from "./DoctorAssessment.vue?vue&type=script&lang=js"
export * from "./DoctorAssessment.vue?vue&type=script&lang=js"
import style0 from "./DoctorAssessment.vue?vue&type=style&index=0&id=f93d0e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93d0e46",
  null
  
)

export default component.exports